export interface Customer {
  id: number;
  company_id: number;
  type: 'NATURAL' | 'JURIDICA';
  doc_number: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  notes?: string;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CustomerCreateData {
  type: 'NATURAL' | 'JURIDICA';
  doc_number: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  notes?: string;
  active?: boolean;
}

export interface CustomerUpdateData extends Partial<CustomerCreateData> {
  id: number;
}

export interface CustomerFilters {
  search?: string;
  type?: 'NATURAL' | 'JURIDICA';
  active?: boolean;
}

export interface CustomerPagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface CustomersResponse {
  customers: Customer[];
  pagination: CustomerPagination;
}

export interface CustomerStats {
  total: number;
  active: number;
  inactive: number;
  natural: number;
  juridica: number;
}

export type CustomerType = 'NATURAL' | 'JURIDICA';

export const CUSTOMER_TYPES: { value: CustomerType; label: string }[] = [
  { value: 'NATURAL', label: 'Persona Natural' },
  { value: 'JURIDICA', label: 'Persona Jurídica' }
];

export interface CustomerFormData {
  type: CustomerType;
  doc_number: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  notes: string;
  active: boolean;
}